import * as React from 'react';

export function useIsMounted(): boolean {
    const isMounted = React.useRef(true);
    React.useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    return isMounted.current || false;
}
